import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'density-confirmation-dialog',
    templateUrl: './density-confirmation-dialog.component.html',
    styleUrls: ['./density-confirmation-dialog.component.scss'],
    standalone: false
})
export class DensityConfirmationDialogComponent {
    @Input()
    isOpen: boolean = false;

    @Input()
    title?: string;

    @Input()
    message?: string;

    @Input()
    innerHtmlMessage: boolean = false;

    @Input()
    useProjectedContent: boolean = false;

    @Input()
    confirmLabel?: string;

    @Input()
    cancelLabel?: string;

    @Input()
    dimensionsConfig: { width?: string } = { width: '592px' };

    @Input()
    isDismissable: boolean = true;

    @Input()
    accentBarTone: 'critical' | 'caution' = 'critical';

    @Input()
    confirmButtonVariant: 'primary' | 'destructive' = 'destructive';

    @Output()
    isOpenChange = new EventEmitter<boolean>();

    @Output()
    confirm = new EventEmitter<void>();

    onOpenChange(isOpen: boolean): void {
        this.isOpen = isOpen;
        this.isOpenChange.emit(isOpen);
    }

    close(): void {
        this.onOpenChange(false);
    }

    onConfirm(): void {
        this.confirm.emit();
    }
}
